import {FC, MouseEventHandler} from "react";
import {useTranslation} from "react-i18next";
import {Button} from "@interstate/components/Button";
import {useNavigation} from "../../../../../navigation";
import {EntitySourceType} from "../../../../EntitySourceType";
import {usePlan} from "../../context";

interface InProgressControlsProps {
  onRetry: MouseEventHandler<HTMLButtonElement>;
}

export const InProgressControls: FC<InProgressControlsProps> = ({onRetry}) => {
  const {t} = useTranslation();
  const {plan} = usePlan();
  const {navigateToEntityFromEvent} = useNavigation();

  return (
    <div data-testid="stepper-controls" className="stepper-controls">
      <div
        data-testid="stepper-controls-left"
        className="stepper-controls-left"
      />
      <div
        data-testid="stepper-controls-right"
        className="stepper-controls-right">
        <Button
          data-testid="step-action-cancel-button"
          buttonStyle="tertiary"
          disabled={true}
          onClick={event =>
            navigateToEntityFromEvent(
              event,
              plan.source.caId,
              EntitySourceType.CLIENT_HIERARCHY
            )
          }>
          {t("create-organization.stepper.controls.actions.cancel")}
        </Button>
        <Button
          data-testid="step-action-create-button"
          buttonStyle="primary"
          onClick={onRetry}
          isLoading={true}>
          {t("create-organization.stepper.controls.actions.retry")}
        </Button>
      </div>
    </div>
  );
};
